// extracted by mini-css-extract-plugin
module.exports = {"root":"DOB_root__2lgtS","foi":"DOB_foi__RBCLY","fields":"DOB_fields__2_A4b"};